// client/src/components/reputation/ReputationBadge.js
import React from 'react';
import { Chip, Tooltip } from '@mui/material';
import { useFeatureFlags } from '../../contexts/FeatureFlagsContext';

const LEVEL_COLORS = {
  0: 'default',
  1: 'default',
  2: 'info',
  3: 'success',
  4: 'warning',
  5: 'error',
};

const LEVEL_NAMES = {
  0: 'New Member',
  1: 'Member',
  2: 'Contributor',
  3: 'Trusted',
  4: 'Curator',
  5: 'Veteran',
};

/**
 * Small trust-level chip shown next to a username.
 * Props: trustLevel (number 0-5), size ('small'|'medium')
 */
export default function ReputationBadge({ trustLevel = 0, size = 'small' }) {
  const { isFeatureEnabled } = useFeatureFlags();
  if (!isFeatureEnabled('enableReputationSystem') || trustLevel === 0) return null;
  return (
    <Tooltip title={`Trust Level ${trustLevel}: ${LEVEL_NAMES[trustLevel]}`}>
      <Chip
        label={LEVEL_NAMES[trustLevel]}
        color={LEVEL_COLORS[trustLevel]}
        size={size}
        sx={{ height: 18, fontSize: '0.65rem', ml: 0.5 }}
      />
    </Tooltip>
  );
}
